import vue from "vue";
const TableCustom = () => import(/* webpackPrefetch: true */'./TableCustom.vue')
vue.component("TableCustom", TableCustom)